import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-view-02-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M4.16663 8.33268H5.83329C7.49996 8.33268 8.33329 7.49935 8.33329 5.83268V4.16602C8.33329 2.49935 7.49996 1.66602 5.83329 1.66602H4.16663C2.49996 1.66602 1.66663 2.49935 1.66663 4.16602V5.83268C1.66663 7.49935 2.49996 8.33268 4.16663 8.33268Z"
        [attr.stroke]="color() || '#6B7280'"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M14.1666 8.33268H15.8333C17.5 8.33268 18.3333 7.49935 18.3333 5.83268V4.16602C18.3333 2.49935 17.5 1.66602 15.8333 1.66602H14.1666C12.5 1.66602 11.6666 2.49935 11.6666 4.16602V5.83268C11.6666 7.49935 12.5 8.33268 14.1666 8.33268Z"
        [attr.stroke]="color() || '#6B7280'"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M14.1666 18.3327H15.8333C17.5 18.3327 18.3333 17.4993 18.3333 15.8327V14.166C18.3333 12.4993 17.5 11.666 15.8333 11.666H14.1666C12.5 11.666 11.6666 12.4993 11.6666 14.166V15.8327C11.6666 17.4993 12.5 18.3327 14.1666 18.3327Z"
        [attr.stroke]="color() || '#6B7280'"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M4.16663 18.3327H5.83329C7.49996 18.3327 8.33329 17.4993 8.33329 15.8327V14.166C8.33329 12.4993 7.49996 11.666 5.83329 11.666H4.16663C2.49996 11.666 1.66663 12.4993 1.66663 14.166V15.8327C1.66663 17.4993 2.49996 18.3327 4.16663 18.3327Z"
        [attr.stroke]="color() || '#6B7280'"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class View02IconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 20 20');
  override fill = input<string>('none');
}
